export enum BinLocationCreationMethodEnum {
  BINS_RANGE = 'bins_range',
  SINGLE_BIN = 'single_bin',
}
